<template>
  <div class="flsa-question-row">
    <v-icon
      v-if="readonly"
      :icon="modelValue ? 'mdi-check-circle' : 'mdi-minus-circle-outline'"
      :class="modelValue ? 'flsa-check-icon-checked' : 'flsa-check-icon-unchecked'"
      size="15"
      class="mt-1 flex-shrink-0"
    />
    <DpplSimpleCheckbox
      v-else
      :model-value="modelValue"
      :option="{ id: questionId, label: '' }"
      hide-label
      class="mt-1"
      @update:model-value="$emit('update:modelValue', $event)"
    />
    <div class="flsa-question-body">
      <div class="text-body-1 text-textDarkest">
        {{ question }}
      </div>
      <div
        v-if="hint || citations.length"
        class="text-body-3 text-textLight flsa-question-detail"
      >
        <template v-if="hint">
          {{ hint }}
        </template>
        <template v-if="citations.length">
          <template v-if="hint">
            {{ ' ' }}
          </template>
          See
          <template
            v-for="(citation, i) in citations"
            :key="`${citation.ref}-${citation.url}`"
          >
            <a
              class="flsa-question-citation-link"
              :href="citation.url"
              target="_blank"
              rel="noopener noreferrer"
            >{{ citation.ref }}</a><span v-if="i < citations.length - 1">, </span>
          </template>.
        </template>
      </div>
    </div>
  </div>
</template>

<script setup>
import DpplSimpleCheckbox from '@/components/datapeople/DpplSimpleCheckbox.vue';

defineProps({
  questionId: {
    type: String,
    required: true,
  },
  question: {
    type: String,
    required: true,
  },
  hint: {
    type: String,
    default: null,
  },
  citations: {
    type: Array,
    default: () => [],
  },
  modelValue: {
    type: Boolean,
    default: false,
  },
  readonly: {
    type: Boolean,
    default: false,
  },
});

defineEmits(['update:modelValue']);
</script>

<style scoped lang="less">
.flsa-question-row {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 16px;

  :deep(input[type=checkbox]) {
    min-width: 15px;
    min-height: 15px;
    width: 15px;
    height: 15px;

    &::before {
      left: 4px;
      width: 5px;
      height: 9px;
    }
  }
}

.flsa-check-icon-checked {
  color: @indigo-500;
}

.flsa-check-icon-unchecked {
  color: @text-lighter;
}

.flsa-question-body {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.flsa-question-detail {
  line-height: 1.5;
}

.flsa-question-citation-link {
  color: @link-default;

  &:hover {
    color: @link-hover;
  }
}
</style>
